import { Button, Card, Space, Typography } from "antd";

import { type FieldTypeSelectorProps } from "../../../_lib/_store";
import { FIELD_TYPES } from "./CreateForm.constant";

const { Text } = Typography;

export const FieldTypeSelector = ({ onAddField }: FieldTypeSelectorProps) => {
  return (
    <Card
      style={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        backgroundColor: "#fff",
        marginBottom: 16,
        borderRadius: 4,
      }}
      styles={{
        body: {
          padding: 12,
        },
      }}
    >
      <Text strong style={{ display: "block", marginBottom: 8 }}>
        Add New Field:
      </Text>

      <Space wrap>
        {FIELD_TYPES.map((type) => (
          <Button
            key={type.value}
            size="middle"
            type="default"
            onClick={() => onAddField(type.value)}
            style={{ lineHeight: 0 }}
          >
            + {type.label}
          </Button>
        ))}
      </Space>
    </Card>
  );
};
